













































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { IEpic, IIssue, IAttachment, IProject } from '@/lib/interfaces';
import vSelect from 'vue-select';
import {
  getEpic,
  getAllIssues,
  updateIssue,
  updateEpic,
  getEpicAttachment,
  addEpicAttachments,
  deleteEpicAttachment,
  getProject,
} from '@/services/api.service';

@Component({
  components: {
    'v-select': vSelect,
  },
})
export default class EpicEditor extends Vue {
  /** Текущий эпик */
  private epic: IEpic = {
    title: '',
    _creator_id: '',
    code: 0,
  };
  /** Проект, которому принадлежит issue */
  private project: IProject | null = null;
  /** Задачи, которые принадлежат текущему проекту */
  private issues: IIssue[] = [];
  private selectedIssue: IIssue | null = null;
  /** Epic до изменений */
  private cachedEpic: IEpic = { ...this.epic };

  private get epicIssues() {
    return this.issues.filter((issue) => issue._epic_id === this.epic._id);
  }

  private get issueSelectOptions() {
    const result: Array<{ label: string; value: IIssue }> = [];
    this.issues.forEach((issue) => {
      if (issue._epic_id !== this.epic._id) {
        result.push({ label: issue.title, value: issue });
      }
    });
    return result;
  }

  /** При изменении полей IEpic */
  private onChangeEpicField<K extends keyof IEpic>(field: K, newValue: IEpic[K]) {
    this.cachedEpic = { ...this.epic };
    this.epic[field] = newValue;
    this.updateEpic();
  }

  private async onSelectIssue(selected: { label: string; value: IIssue }) {
    let cachedValue: string | undefined;
    if (selected) {
      cachedValue = selected.value._epic_id;
      this.$set(selected.value, '_epic_id', this.epic._id);
      try {
        await updateIssue(selected.value);
      } catch (err) {
        selected.value._epic_id = cachedValue;
      }
      this.selectedIssue = null;
    }
  }

  /** Сохраняем изменения epic */
  private async updateEpic() {
    try {
      await updateEpic(this.epic, this.$route.params.project_id);
    } catch (err) {
      // Возвращаем закешированные данные, не забывая про реактивность
      for (const key in this.cachedEpic) {
        if (this.cachedEpic.hasOwnProperty(key)) {
          Vue.set(this.epic, key, this.cachedEpic[key]);
        }
      }
    }
  }

  private async beforeRouteEnter(to: Route, from: Route, next: (vm?: any) => void) {
    const [epic, issues, project] = await Promise.all([
      getEpic(to.params.project_id, to.query.epic_id as string),
      getAllIssues({ project: to.params.project_id, deleted: false }),
      getProject(to.params.project_id),
    ]);
    next((vm: EpicEditor) => {
      vm.epic = epic;
      vm.issues = issues;
      vm.project = project;
    });
  }

  private async onClickAttachment(attachment: IAttachment) {
    getEpicAttachment(this.$route.params.project_id, this.epic._id!, attachment._id);
  }

  private async onAddAttachments({ target }: { target: HTMLInputElement }) {
    const form = new FormData();
    if (target.files) {
      /* tslint:disable-next-line:prefer-for-of */
      for (let i = 0; i < target.files.length; i++) {
        const file = target.files[i];
        form.append('attachments', file, file.name);
      }
    }
    const { attachments } = await addEpicAttachments(this.$route.params.project_id, this.epic._id!, form);
    this.epic.attachments = attachments;
  }

  private async onClickDeleteAttachment(attachment: IAttachment) {
    await deleteEpicAttachment(this.$route.params.project_id, this.epic._id!, attachment._id);
    for (const i in this.epic.attachments!) {
      if (this.epic.attachments![i]._id === attachment._id) {
        this.epic.attachments!.splice(+i, 1);
        break;
      }
    }
  }
}
